import { OrderReturn } from 'khufu-legos';
import { Fragment } from 'react';
import { Col, Row, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { currencyFormatter } from '../../../helpers/currencyFormatter';

interface OrderReturnsProps {
  returns: OrderReturn[];
  returnedTotal: number;
}

// The returns raised against a source order, as the middle step of
// ordered - returned = due. Each return is a standard return: its items went back
// into inventory when it was made, and nothing here carries into a later order.
const OrderReturns = ({ returns, returnedTotal }: OrderReturnsProps) => {
  if (returns.length === 0) {
    return null;
  }

  return (
    <>
      <Row>
        <Col className="text-center">
          <h4 className="mt-5">
            Returns (
            {returns.map((orderReturn, index) => (
              <Fragment key={orderReturn._id.toString()}>
                {index > 0 && ', '}
                {/* Headings inherit their colour into child links; keep this one looking like a link. */}
                <Link to={`/return-order/${orderReturn._id}`} className="link-primary">
                  {orderReturn.returnOrderNumber}
                </Link>
              </Fragment>
            ))}
            )
          </h4>
        </Col>
      </Row>
      <Table className="my-4" responsive>
        <thead>
          <tr>
            <th className="px-4 bg-transparent border-top-0">
              <span className="h6">Product</span>
            </th>
            <th className="px-4 bg-transparent border-top-0 text-end">
              <span className="h6">Qty</span>
            </th>
            <th className="px-4 bg-transparent border-top-0 text-end">
              <span className="h6">Price</span>
            </th>
            <th className="px-4 bg-transparent border-top-0 text-end">
              <span className="h6">Total</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {returns.map(orderReturn =>
            orderReturn.items.map(item => (
              <tr key={item._id.toString()}>
                <td className="px-4">{item.name}</td>
                <td className="px-4 text-end">{item.quantity}</td>
                <td className="px-4 text-end">{currencyFormatter(item.price)}</td>
                <td className="px-4 text-end">{currencyFormatter(item.total)}</td>
              </tr>
            ))
          )}
          <tr>
            <td className="px-4 border-top border-top-2">
              <strong>Returned</strong>
            </td>
            <td colSpan={3} className="px-4 text-end border-top border-top-2">
              <span className="h3">{currencyFormatter(-returnedTotal)}</span>
            </td>
          </tr>
        </tbody>
      </Table>
    </>
  );
};

export default OrderReturns;
